import { Card, CardContent, CardHeader } from "../Card";
import Image from "../Image/Image";
import { useTranslation } from 'react-i18next'

type Props = {
    documents: {path: string}[]
    title?: string
}


export function DocumentsViewer({documents}: Props) {

   const { t } = useTranslation();


    if(documents.length === 0) {
        return null
    }

    return (
        <Card>
        <CardHeader>
          <h2 className="text-lg font-bold">{t('documents')}</h2>
        </CardHeader>
        <CardContent>
          <div className="flex gap-2 flex-wrap">
            {documents.map((doc, index) => (
              <div className="" key={index}>
                <Image
                  allowZoom={true}
                  className="object-cover h-32 w-32"
                  path={doc.path}
                />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    )
}
